import { Model } from '@vuex-orm/core';
import Zaui from '@/include/api';

export default class PortalSettings extends Model {
  static entity = 'portalsettings';

  get enableGiftCert() {
    return this.enableGiftCertCustomAmount || this.enableGiftCertDenom;
  }

  static fields() {
    return {
      id: this.number(),
      uuid: this.string(),
      valid: this.boolean(),
      slug: this.string(),
      showLowestPrice: this.boolean(),
      enableGiftCertCustomAmount: this.boolean(),
      enableGiftCertDenom: this.boolean(),
      giftCertDenom: this.number(),
      giftCertMax: this.number(),
      p2pLabel: this.string(),
      lang: this.attr({
        default: 'en-US',
        choices: [],
        overrides: {}
      }),
      currency: this.attr({
        default: 'USD',
        active: 'USD',
        choices: ['USD']
      }),
      landingPage: this.attr(),
      menuOptions: this.attr(),
      paymentFields: this.attr(),
      paymentGateway: this.attr(),
      stripePublicKey: this.attr(),
      stripeConnectAccountId: this.attr(),
      policies: this.string(),
      termsOfService: this.string(),
      companyDetails: this.attr(),
      themeFontFamily: this.string(),
      themePrimaryColor: this.string(),
      themeSecondaryColor: this.string(),
      themeCtaColor: this.string(),

      requiredFrontEndPickup: this.boolean(),
      p2pAvailabilityShowErrorBookingChildrenOnly: this.boolean(),
      infantsAreResponsiblePeople: this.boolean(),

      portalAddOns: this.attr([])
    };
  }

  static get(key=null, fallback=undefined) {
    // there should only ever be 1 settings.
    let ps = PortalSettings.query().first();
    return ps && key && typeof(ps[key]) !== 'undefined' ? ps[key] : (fallback !== undefined ? fallback : ps);
  }
}